<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <form class="form-custom clearfix" novalidate="novalidate" @submit.prevent="submitHandler">
        <div class="section-title">
          <h1>注册<span class="square">REGISTER</span></h1>
        </div>
        <div class="form-group has-feedback" :class="{'has-success': (checkPhone != null) && checkPhone,'has-error': (checkPhone != null) && !checkPhone}">
          <label class="control-label">手机号</label>
          <div>
            <input class="form-control" type="text" v-model="phone" maxlength="11" placeholder="请输入手机号" @blur="validatePhone">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkPhone != null" :class="{'glyphicon-ok': checkPhone,'glyphicon-remove': !checkPhone}"></span>
          <span class="help-block">{{phoneMsg}}</span>
        </div>
        <div class="form-group has-feedback" :class="{'has-success': (checkPassword != null) && checkPassword,'has-error': (checkPassword != null) && !checkPassword}">
          <label class="control-label">密码</label>
          <div>
            <input class="form-control" type="password" v-model="password" placeholder="请输入登录密码" @blur="validatePassword">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkPassword != null" :class="{'glyphicon-ok': checkPassword,'glyphicon-remove': !checkPassword}"></span>
          <span class="help-block">{{passwordMsg}}</span>
        </div>
        <div class="form-group capt-box has-feedback" :class="{'has-success': (checkCaptText != null) && checkCaptText,'has-error': (checkCaptText != null) && !checkCaptText}">
          <label class="control-label">验证码</label>
          <div>
            <input class="form-control input-capt" type="text" v-model="captText" maxlength="4" placeholder="请输入验证码" @blur="validateCapt">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkCaptText != null" :class="{'glyphicon-ok': checkCaptText,'glyphicon-remove': !checkCaptText}"></span>
          <span class="help-block">{{captTextMsg}}</span>
          <div class="capt">
            <a href="javascript:;" title="点击更换验证码" @click="updateCapt"><img :src="captUrl"></a>
          </div>
        </div>
        <div class="form-group mobile-code-box has-feedback" :class="{'has-success': (checkPhoneCapt != null) && checkPhoneCapt,'has-error': (checkPhoneCapt != null) && !checkPhoneCapt}">
          <label class="control-label">短信验证码</label>
          <div>
            <input class="form-control input-mobile-code" type="text" v-model="phoneCapt" maxlength="6" placeholder="请输入短信验证码" @blur="validatePhoneCapt">
          </div>
          <span class="glyphicon form-control-feedback" v-show="checkPhoneCapt != null" :class="{'glyphicon-ok': checkPhoneCapt,'glyphicon-remove': !checkPhoneCapt}"></span>
          <span class="help-block">{{phoneCaptMsg}}</span>
          <div class="mobile-code">
            <button class="btn-code" type="button" @click="getPhoneCapt" :disabled="disabled">{{text}}</button>
          </div>
        </div>
        <div class="form-group btn-wrap">
          <button class="btn" type="submit">注册<span class="iconfont">&#xe65a;</span></button>
          <p class="err-wrap"><span>{{errmsg}}</span>&nbsp;</p>
          <span class="protocol">我接受
            <a href="javascript:;" @click="show=true">《注册协议》</a>
          </span>
        </div>
        <div class="form-group btn-wrap">
          <button class="btn btn-login" type="button" @click="toLogin">已有账号 去登录</button>
        </div>
      </form>
      <div class="copy">
        &copy; 2017 <span>北京伟嘉安捷投资担保有限公司</span> All rights reserved&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;京ICP备16040229号-2
      </div>
    </div>
    <modal :show="show" @dismiss="show=false" class="protocol-dialog">
      <div class="modal-wrap" style="width:1140px;padding:20px 20px 0">
        <h1 class="text-center" style="margin-top:0px;margin-bottom:20px;font-size:28px;font-weight:normal">注册协议</h1>
        <iframe src="/xieyi/yh.jsp" frameborder="0" scrolling="yes" style="width:100%;min-height:300px;overflow:auto" ref="frame" :style="{height:viewHeight + 'px'}"></iframe>
        <div class="text-center" style="padding:20px">
          <button type="button" class="btn btn-primary" @click="show=false" style="padding:12px 30px">同意协议</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script type="text/javascript">
  import Modal from '@/components/modal/modal'
  import {bindEvent, removeEvent} from '@/util'

  export default {
    name: 'Register',
    components: {Modal},
    data () {
      return {
        show: false,
        captUrl: '',
        errmsg: '',
        disabled: false,
        text: '获取验证码',
        viewHeight: 300,
        phone: '',
        checkPhone: null,
        phoneMsg: '',
        captText: '',
        checkCaptText: null,
        captTextMsg: '',
        phoneCapt: '',
        checkPhoneCapt: null,
        phoneCaptMsg: '',
        password: '',
        checkPassword: null,
        passwordMsg: ''
      }
    },
    created () {
      this.updateCapt()
    },
    mounted () {
      this.resizeHandle = () => {
        this.onResize()
      }
      this.onResize()
      bindEvent(window, 'resize', this.resizeHandle)
    },
    beforeDestroy () {
      removeEvent(window, 'resize', this.resizeHandle)
    },
    methods: {
      updateCapt () {
        this.$store.commit('updateCaptId')
        this.captUrl = '/captchaImage.jhtml?captId=' + this.$store.state.captId + '&sr=0'
      },
      onResize () {
        clearTimeout(this.__timer)
        this.__timer = setTimeout(() => {
          let clientHeight = (document.documentElement || document.body).clientHeight
          this.viewHeight = clientHeight - 240
        }, 300)
      },
      validatePhone () {
        this.checkPhone = this.validate(false, 'phone')
        this.checkPhone && (this.phoneMsg = '')
        !this.checkPhone && (this.errmsg = '')
      },
      validatePassword () {
        this.checkPassword = this.validate(false, 'password')
        this.checkPassword && (this.passwordMsg = '')
        !this.checkPassword && (this.errmsg = '')
      },
      validateCapt () {
        this.checkCaptText = this.validate(false, 'captText')
        this.checkCaptText && (this.captTextMsg = '')
        !this.checkCaptText && (this.errmsg = '')
      },
      validatePhoneCapt () {
        this.checkPhoneCapt = this.validate(false, 'phoneCapt')
        this.checkPhoneCapt && (this.phoneCaptMsg = '')
        !this.checkPhoneCapt && (this.errmsg = '')
      },
      validate (isCapt, choice) {
        let rules = {
          phone: {
            patterns: [{
              pattern: this.$validate.patterns.phone,
              msg: '请输入正确的手机号'
            }],
            required: '请输入手机号'
          },
          captText: {
            patterns: [{
              pattern: this.$validate.patterns.capt,
              msg: '请输入正确的验证码'
            }],
            required: '请输入图形验证码'
          }
        }
        if (isCapt) {
          // let msgField = 'phoneCaptMsg'
          return this.$validate({rules})
        } else {
          Object.assign(rules, {
            password: {
              patterns: [{
                pattern: this.$validate.patterns.password,
                msg: '密码应为6-16位字母数字的组合，且不能包含空格'
              }],
              required: '请输入密码'
            },
            phoneCapt: {
              patterns: [{
                pattern: /^\d{6}$/,
                msg: '请输入正确的短信验证码'
              }],
              required: '请输入短信验证码'
            }
          })
          if (choice) {
            let obj = {}
            obj[choice] = rules[choice]
            rules = obj
          }
          // let msgField = choice ? choice + 'Msg' : 'errmsg'
          return this.$validate({rules})
        }
      },
      getPhoneCapt () {
        if (this.validate(true)) {
          let vm = this
          this.errmsg = ''
          this.$http({
            url: '/sendPhoneCaptcha.jhtml',
            data: {
              phone: this.phone,
              business: '1001',
              captId: this.$store.state.captId,
              captText: this.captText
            },
            done (d, p, r) {
              vm.$dialog(r.msg)
              vm.countdown()
            },
            fail (m) {
              vm.checkPhoneCapt = false
              vm.phoneCaptMsg = m
              vm.updateCapt()
            }
          })
        } else {
          this.errmsg = ''
          this.checkPhoneCapt = false
        }
      },
      countdown (t) {
        if (t === undefined) {
          t = 60
        }
        if (--t > 0) {
          this.disabled = true
          this.text = `${t}秒后重试`
          setTimeout(() => {
            this.countdown(t)
          }, 1000)
        } else {
          this.disabled = false
          this.text = '重新获取'
        }
      },
      toLogin () {
        this.$router.push('/login')
      },
      submitHandler (e) {
        if (this.validate()) {
          let vm = this
          let {phone, captText, phoneCapt, password} = this
          this.$http({
            url: '/register.jhtml',
            data: {
              captId: this.$store.state.captId,
              phone,
              captText,
              phoneCapt,
              password: this.$md5(password)
            },
            done (d, p, r) {
              vm.$dialog({
                content: r.msg,
                onHide () {
                  vm.$store.commit('updateToken', Object.assign({}, d, {phone}))
                  let backurl = vm.$route.query.backurl
                  if (backurl) {
                    window.location.href = backurl
                    return
                  }
                  if (d.status === 0) {
                    vm.$router.push('/authentication')
                  } else {
                    vm.$router.push('/')
                  }
                }
              })
            },
            fail (m) {
              vm.errmsg = m
              vm.updateCapt()
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .form-custom
    width 946px
    /*height 535px*/
    padding 46px 0 32px 60px
    margin 65px auto 100px
    box-shadow none
    .form-group
      float left
      width 415px
      margin-bottom 22px
      &:nth-child(2n)
        margin-right 50px
    .form-control
      width 365px
    .btn-wrap
      padding-top 60px
      padding-bottom 40px
      .btn
        width 365px
        height 60px
      .btn-login
        border 1px solid #e6e6e6
        color #999
        background-color transparent
    .input-mobile-code
      padding-right 132px
    .mobile-code
      width 132px
      height 60px
      position absolute
      right 50px
      top 28px
      .btn-code
        width 100%
        height 100%
        background-color rgb(43, 158, 252)
        border 0
        color #fff
        letter-spacing 4px
  .copy
    text-align center
    margin-bottom 10px
    font-size 12px
    color #fff
    span
      color #2b9efc
</style>




// WEBPACK FOOTER //
// register.vue?d69f4eac